/** @jsx jsx */
import { jsx } from "theme-ui"
import Carousel from "@components/Carousel"
import Testimonial from "@components/Testimonial"
import PropTypes from "prop-types"
import Banner from "@components/Banner"
/**
 * @todo mobile/tablet arrow position
 */
const TestimonialCarousel = ({ testimonials, heading }) => (
  <div>
    {heading ? <div sx={{ textAlign: 'center', mb: 10 }}>
      <Banner title={heading} />
    </div> : null}
    <Carousel
      containerStyle={{
        width: "80%",
        mx: "auto",
      }}
      settings={{
        dots: false,
      }}
    >
      {testimonials.map(({ text, ...testimonial }, index) => (
        <div key={index} sx={{ px: 3 }}>
          <Testimonial body={text} {...testimonial} />
        </div>
      ))}
    </Carousel>
  </div>
)

export default TestimonialCarousel

TestimonialCarousel.propTypes = {
  heading: PropTypes.string,
  testimonials: PropTypes.arrayOf(
    PropTypes.shape({
      heading: PropTypes.string,
      text: PropTypes.string,
      subtext: PropTypes.string,
      image: PropTypes.string,
      footnote: PropTypes.string,
    })
  ),
}
